export default __webpack_public_path__ + "static/media/Snd_22.1e3e6107.mp3";